import purchase_link from './purchase_link.vue'
const PurchaseLink = {
    install: function (Vue) {
        Vue.component('PurchaseLink', purchase_link)
    }
}
export default PurchaseLink
